import { render, staticRenderFns } from "./InviteStudentDialog.vue?vue&type=template&id=e061e122&scoped=true"
import script from "./InviteStudentDialog.vue?vue&type=script&lang=js"
export * from "./InviteStudentDialog.vue?vue&type=script&lang=js"
import style0 from "./InviteStudentDialog.vue?vue&type=style&index=0&id=e061e122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e061e122",
  null
  
)

export default component.exports